const minutesSince = (value, now = Date.now()) => {
    if (!value) return null;
    const timestamp = new Date(value).getTime();
    if (Number.isNaN(timestamp)) return null;
    return Math.max(0, Math.floor((now - timestamp) / 60000));
};

export const withOpenComplaintSortFields = (complaint, now = Date.now()) => {
    const ageSortMinutes = minutesSince(complaint?.createdAt, now);
    const waitingAt = complaint?._signals?.needsAgentReply
        ? complaint._signals.lastCustomerMessageAt || complaint.createdAt
        : null;
    const waitingSortMinutes = minutesSince(waitingAt, now);
    return {
        ...complaint,
        ageSortMinutes: ageSortMinutes ?? -1,
        waitingSortMinutes: waitingSortMinutes ?? -1
    };
};

export { minutesSince };
